// src/lib/cartStore.js
const KEY = "guest_cart_v1";

// 🔹 Lire le panier
export function getCart() {
  try {
    const raw = localStorage.getItem(KEY) || "[]";
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed;
  } catch {
    return [];
  }
}

// 🔹 Écrire le panier + notifier les listeners
export function setCart(items) {
  const safe = Array.isArray(items) ? items : [];
  localStorage.setItem(KEY, JSON.stringify(safe));
  notifyCartListeners();
}

// 🔹 Ajouter / mettre à jour une ligne
//    item attendu: { pid, vendorId?, qty }
export function addToCart(item) {
  if (!item || !item.pid) return;

  const { pid, vendorId = "goshop", qty = 1 } = item;
  if (!qty) return;

  const cart = getCart();
  const i = cart.findIndex((x) => x.pid === pid);

  if (i >= 0) {
    const currentQty = Number(cart[i].qty || 0);
    const nextQty = currentQty + qty;

    if (nextQty <= 0) {
      cart.splice(i, 1);
    } else {
      cart[i] = {
        ...cart[i],
        qty: nextQty,
      };
    }
  } else {
    if (qty > 0) {
      cart.push({
        pid,
        vendorId,
        qty,
      });
    }
  }

  setCart(cart);
}

// 🔹 Supprimer un produit du panier
export function removeFromCart(pid) {
  const cart = getCart().filter((x) => x.pid !== pid);
  setCart(cart);
}

// 🔹 Vider le panier
export function clearCart() {
  setCart([]);
}

/* ------------------------------------------------------------------ */
/* 🔔 Système d'abonnement utilisé par le header pour le compteur     */
/* ------------------------------------------------------------------ */

let cartListeners = [];

// Listener reçoit toujours le panier complet à jour
export function subscribeCart(listener) {
  if (typeof listener !== "function") return () => {};

  cartListeners.push(listener);

  return () => {
    cartListeners = cartListeners.filter((fn) => fn !== listener);
  };
}

function notifyCartListeners() {
  const cart = getCart();
  cartListeners.forEach((fn) => {
    try {
      fn(cart);
    } catch {
      // ignore
    }
  });
}
